module.exports = __webpack_public_path__ + "static/pooh-v2-03-04c4ef9ee0eb4554093b48dd9b0308ad.jpg";